{
  "fr": {
    "overview": {
      "actions": {
        "select_decision": "Choisir une décision",
        "select_installment": "Sélectionnez la tranche de paiement",
        "select_point_list": "Sélectionner la liste de points",
        "select_survey": "Sélectionner une formulaire"
      },
      "table": {
        "labels": {
          "category": "Catégorie",
          "level": "Niveau",
          "status": "Statut"
        }
      }
    }
  }
}